<p-dialog header="Clientes de impresión" [(visible)]="visible" (visibleChange)="visibleChange.emit($event)" (onShow)="onShow()"
          [modal]="true" [dismissableMask]="true" [style]="{width: '640px'}" [breakpoints]="{'680px': '95vw'}" appendTo="body">

    <ng-container *ngIf="adding">
        <div class="pc-toolbar">
            <button pButton type="button" icon="pi pi-arrow-left" label="Volver" class="p-button-text p-button-sm"
                    (click)="stopAdding()"></button>
        </div>

        <div class="pc-add-field">
            <label for="pc-office">Punto de venta</label>
            <p-dropdown inputId="pc-office" [options]="offices" optionLabel="nombre" optionValue="codigo" [(ngModel)]="officeCode"
                        (onChange)="pairingCode = null" appendTo="body" styleClass="w-full"></p-dropdown>
        </div>

        <div class="pc-install" *ngIf="installerUrl">
            <i class="pi pi-download"></i>
            <div class="pc-local-text">
                <b>{{localClient ? '¿Necesitas reinstalar o actualizar?' : 'Instala el servicio en la PC de la impresora'}}</b>
                <small>Instalador para Windows con todo lo necesario. Si ya estaba instalado, se actualiza y conserva su configuración.</small>
            </div>
            <a pButton icon="pi pi-download" label="Descargar" [href]="installerUrl" class="p-button-sm"
               [class.p-button-outlined]="!!localClient"></a>
        </div>

        <div class="pc-local" *ngIf="localClient">
            <i class="pi pi-desktop"></i>
            <div class="pc-local-text">
                <b>Servicio de impresión detectado en esta PC</b>
                <small>{{localClient.deviceName}} · v{{localClient.version}} ·
                    {{localClient.paired ? 'vinculado a ' + localClient.officeCode : 'sin vincular'}}</small>
            </div>
            <button pButton type="button" icon="pi pi-link" [label]="localClient.paired ? 'Volver a vincular' : 'Vincular esta PC'"
                    class="p-button-sm" [loading]="pairingLocal" [disabled]="!officeCode" (click)="pairThisComputer()"></button>
        </div>

        <div class="pc-code-box">
            <p class="pc-code-title">{{localClient ? '¿La impresora está en otra PC?' : 'Vincular una PC con el código'}}</p>
            <ol class="pc-steps">
                <li>En la PC que tiene la impresora, abre el <b>servicio de impresión de {{brand}}</b>.</li>
                <li>Haz clic en <b>Vincular con código</b> y escribe el código que aparece aquí.</li>
            </ol>
            <div class="pc-code" *ngIf="pairingCode">
                <div class="pc-code-row">
                    <span class="pc-code-value">{{pairingCode.code}}</span>
                    <button pButton type="button" class="p-button-text p-button-rounded"
                            [icon]="codeCopied ? 'pi pi-check' : 'pi pi-copy'"
                            [pTooltip]="codeCopied ? 'Copiado' : 'Copiar código'" tooltipPosition="top"
                            (click)="copyCode()"></button>
                </div>
                <small>Un solo uso · vence a las {{pairingCode.expiresAt | date:'HH:mm'}}</small>
            </div>
            <button pButton type="button" icon="pi pi-key" class="p-button-outlined p-button-sm"
                    [label]="pairingCode ? 'Generar otro código' : 'Generar código'" [loading]="generating"
                    [disabled]="!officeCode" (click)="generateCode()"></button>
        </div>
    </ng-container>

    <ng-container *ngIf="!adding">
    <div class="pc-toolbar">
        <span class="pc-hint">PCs con el servicio de impresión de {{brand}} conectadas a tu empresa.</span>
        <span class="pc-toolbar-actions">
            <button pButton type="button" icon="pi pi-plus" label="Agregar equipo" class="p-button-sm"
                    (click)="startAdding()"></button>
            <button pButton type="button" icon="pi pi-refresh" class="p-button-text p-button-sm" pTooltip="Actualizar"
                    tooltipPosition="left" [loading]="loading" (click)="load()"></button>
        </span>
    </div>

    <div class="pc-empty" *ngIf="loaded && !groups.length">
        <i class="pi pi-print"></i>
        <p>No hay ningún cliente de impresión conectado.</p>
        <small>Abre el servicio de impresión de {{brand}} en la PC que tiene la impresora conectada.</small>
        <div class="pc-empty-actions">
            <a *ngIf="installerUrl" pButton icon="pi pi-download" label="Descargar instalador" [href]="installerUrl"
               class="p-button-outlined p-button-sm"></a>
            <button pButton type="button" icon="pi pi-plus" label="Agregar equipo" class="p-button-sm"
                    (click)="startAdding()"></button>
        </div>
    </div>

    <section class="pc-group" *ngFor="let group of groups">
        <h4 class="pc-group-title">
            <span>Punto de venta {{group.officeCode}}</span>
            <small>{{group.clients.length}} {{group.clients.length === 1 ? 'equipo' : 'equipos'}}</small>
        </h4>

        <div class="pc-warn" *ngIf="group.legacyActive > 1">
            <i class="pi pi-exclamation-triangle"></i>
            Hay {{group.legacyActive}} clientes de versión antigua con este código: solo recibe el que se conectó primero.
            Bloquea los que ya no se usan.
        </div>

        <div class="pc-client" *ngFor="let client of group.clients; trackBy: trackBySocket" [class.is-blocked]="client.blocked">
            <div class="pc-client-main">
                <i class="pi pi-desktop pc-client-icon"></i>
                <div class="pc-client-info">
                    <div class="pc-client-name">
                        <span>{{client.deviceName || 'Equipo sin identificar'}}</span>
                        <p-tag *ngIf="client.isDefault" value="Principal" severity="success"></p-tag>
                        <p-tag *ngIf="client.legacy" value="Versión antigua" severity="warning"></p-tag>
                        <p-tag *ngIf="client.blocked" value="Bloqueado" severity="danger"></p-tag>
                    </div>
                    <small class="pc-client-meta">
                        {{client.version ? 'v' + client.version : 'Sin versión'}} · IP {{client.ip}}
                        · conectado {{client.connectedAt | date:'dd/MM HH:mm'}}
                    </small>
                    <div class="pc-printers" *ngIf="client.printers?.length">
                        <span class="pc-printer" *ngFor="let printer of client.printers"><i class="pi pi-print"></i>{{printer}}</span>
                    </div>
                    <small class="pc-client-meta" *ngIf="client.legacy && !client.blocked">
                        Esta versión no informa sus impresoras ni acepta acciones remotas. Actualízala para administrarla desde aquí.
                    </small>
                </div>
            </div>

            <div class="pc-actions" *ngIf="!client.legacy">
                <button pButton type="button" icon="pi pi-print" label="Probar" class="p-button-outlined p-button-sm"
                        [disabled]="!client.printers?.length || busySocketId === client.socketId"
                        (click)="openTestMenu(testMenu, $event, client)"></button>
                <button pButton type="button" class="p-button-text p-button-sm"
                        [icon]="client.isDefault ? 'pi pi-star-fill' : 'pi pi-star'"
                        [pTooltip]="client.isDefault ? 'Quitar como principal' : 'Marcar como principal'" tooltipPosition="top"
                        [disabled]="busySocketId === client.socketId" (click)="toggleDefault(client)"></button>
                <button pButton type="button" icon="pi pi-replay" class="p-button-text p-button-sm" pTooltip="Reiniciar conexión"
                        tooltipPosition="top" [disabled]="busySocketId === client.socketId" (click)="restart(client)"></button>
                <button pButton type="button" icon="pi pi-power-off" class="p-button-text p-button-danger p-button-sm"
                        pTooltip="Desactivar" tooltipPosition="top" [disabled]="busySocketId === client.socketId"
                        (click)="disable(client)"></button>
                <button *ngIf="canRemove(client)" pButton type="button" icon="pi pi-trash"
                        class="p-button-text p-button-danger p-button-sm" pTooltip="Quitar equipo" tooltipPosition="top"
                        [disabled]="busySocketId === client.socketId" (click)="remove(client)"></button>
            </div>
            <div class="pc-actions" *ngIf="client.legacy && !client.blocked">
                <button pButton type="button" icon="pi pi-ban" label="Bloquear" class="p-button-outlined p-button-danger p-button-sm"
                        [disabled]="busySocketId === client.socketId" (click)="block(client)"></button>
            </div>
        </div>
    </section>

    <section class="pc-group" *ngIf="blocks.length">
        <h4 class="pc-group-title"><span>Clientes antiguos bloqueados</span></h4>
        <div class="pc-block" *ngFor="let rule of blocks">
            <span>{{rule.officeCode}} · {{rule.ip ? 'IP ' + rule.ip : 'cualquier IP'}} · desde {{rule.createdAt | date:'dd/MM/yyyy HH:mm'}}</span>
            <button pButton type="button" label="Desbloquear" class="p-button-text p-button-sm" (click)="unblock(rule)"></button>
        </div>
    </section>

    </ng-container>

    <p-menu #testMenu [popup]="true" [model]="testMenuItems" appendTo="body"></p-menu>
</p-dialog>
